/**
 * First Copilot message for self-serve onboarding (sample or own data).
 * Asks for a business-friendly overview; asks Copilot for exactly 3 chart questions and to run the first automatically.
 */
export const ONBOARDING_DATA_OVERVIEW_PROMPT = `As a business user, help me understand the data we have connected:

• In a few short lines, what does this data represent overall (the “story” of the dataset)?
• What are the main business entities here (for example customers, orders, campaigns, products) and how they fit together?
• Suggest exactly 3 concrete chart-style analytics questions I could ask next (number them 1, 2, 3). Each should name a chart type when it helps (bar, line, pie, etc.).

Please keep answers concise and non-technical, then run the first question automatically for me so I do not need to send another message.`;
